var map = {
	"./blackGold/header/backBtn.png": 83277,
	"./brownGold/header/backBtn.png": 72566,
	"./darkBlue/header/backBtn.png": 11006,
	"./greenYellow/header/backBtn.png": 82338,
	"./redGold/header/backBtn.png": 67763,
	"./skyBlue/header/backBtn.png": 77695,
	"./whiteGold/header/backBtn.png": 37458,
	"./yellowWhite/header/backBtn.png": 25848
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43708;